import React, { useState } from "react";

interface IProps {
    labels: string[];
    active?: number;
    onChange: (idx: number) => void;
};

function Tabbing(props: IProps) {
    const [active, setActive] = useState(props.active ? props.active : 0);
    const renderLabel = (label: string, idx: number) => {
        return (
            <div 
                key={"tab_" + idx}
                onClick={() => {setActive(idx); props.onChange(idx); }}
                className={active === idx ? "tab_active" : ""}
            >
                {label}
            </div>
        );
    };
    const tabStyle = `repeat(${props.labels.length}, 1fr)`;
    return (
        <div className="tabbingbox" style={{gridTemplateColumns: tabStyle}}>
            {props.labels.map(renderLabel)}
      </div>
    );
};
export default (Tabbing);